import { useCallback, useRef } from 'react'
import { newIdempotencyKey } from './api'

/**
 * A chave de idempotência de um `POST` que cria (docs/api/README.md). A chave pertence à intenção,
 * não ao clique: repetir o mesmo corpo (a resposta se perdeu, a pessoa clicou de novo) reusa a
 * chave, e a API devolve a resposta guardada em vez de criar outra vez. Corpo diferente, chave
 * nova. Depois que a criação dá certo, `reset` encerra a intenção.
 */
export function useIdempotencyKey() {
  const last = useRef<{ fingerprint: string; key: string } | null>(null)
  const keyFor = useCallback((body: unknown) => {
    const fingerprint = JSON.stringify(body ?? null)
    if (last.current?.fingerprint !== fingerprint) {
      last.current = { fingerprint, key: newIdempotencyKey() }
    }
    return last.current.key
  }, [])
  const reset = useCallback(() => {
    last.current = null
  }, [])
  return { keyFor, reset }
}
